module.exports = __webpack_public_path__ + "static/media/AE.4378a85a.png";